<script setup>
import { usePrefetchData,LOADED, } from '@/assets/js/src/util/composables/usePrefetchData'
import { usePartnerStore, } from '@/assets/js/src/modules/partner/_pinia/partner'
import { storeToRefs,getActivePinia, } from 'pinia'
import LoadingDummyBox from '@/assets/js/src/components/loading/LoadingDummyBox'
import PartnerCard from '@/assets/js/src/modules/partner/_components/PartnerCard.vue'

defineProps({
    shadow: {
        type: Boolean,
        default: true,
    },
})
    
let partnerStore = usePartnerStore(getActivePinia())

const { publishers, } = storeToRefs(partnerStore)
const { asyncStatus, } = usePrefetchData({
    actions: [
        {
            item: publishers,
            action: partnerStore.getPublishers,
            payload: {},
        },
    ],
})
</script>

<template>
    <v-row
        class="partner-list flex-wrap justify-start"
    >
        <template
            v-if="asyncStatus === LOADED"
        >
            <v-col
                v-for="publisher in publishers"
                :key="publisher.id"
                lg="2"
                md="3"
                sm="4"
                cols="6"
            >
                <partner-card
                    :shadow="shadow"
                    :publisher="publisher"
                ></partner-card>
            </v-col>
        </template>
        <template v-else>
            <v-col
                v-for="n in 18"
                :key="'partner_lb_'+n"
                lg="2"
                md="3"
                sm="4"
                cols="6"
            >
                <loading-dummy-box></loading-dummy-box>
            </v-col>
        </template>
    </v-row>
</template>

<style lang="scss">
    .bs-app {
        .partner-list {
            margin-top: 24px !important;
        }
    }
</style>
